import React from 'react';
import { Icon } from '@iconify/react';

export const MultiSourceVisual = () => {
  return (
    <div className="w-[90%] h-[85%] bg-white rounded-xl shadow-lg border border-gray-100 flex flex-col overflow-hidden relative">
        {/* Header */}
        <div className="h-8 border-b border-gray-50 flex items-center justify-between px-3 bg-gray-50/50">
            <div className="flex items-center gap-1.5 text-gray-500">
                <Icon icon="mdi:calendar" width={10} />
                <span className="text-[9px] font-semibold">December 2025</span>
            </div>
            <div className="bg-blue-100 text-blue-900 text-[8px] font-bold px-2 py-0.5 rounded-full flex items-center gap-1">
                <Icon icon="mdi:plus" width={8} /> Create Post
            </div>
        </div>

        {/* Calendar Grid */}
        <div className="flex-1 p-2 grid grid-cols-3 gap-2">

            {/* Day 1 - Empty */}
            <div className="border border-gray-100 rounded-lg p-1.5 flex flex-col gap-1 bg-gray-50/30">
                <div className="text-[8px] text-gray-400 font-medium">13 Mon</div>
            </div>

            {/* Day 2 - Scheduled */}
            <div className="border border-purple-100 bg-purple-50/30 rounded-lg p-1.5 flex flex-col gap-1 relative group hover:border-purple-300 transition-colors cursor-pointer">
                <div className="text-[8px] text-purple-400 font-medium">14 Tue</div>
                <div className="bg-white rounded border border-purple-100 p-1.5 shadow-sm">
                    <div className="flex items-center justify-between mb-1">
                        <Icon icon="mdi:instagram" width={10} className="text-pink-500" />
                        <Icon icon="mdi:clock-outline" width={8} className="text-gray-400" />
                    </div>
                    <div className="w-full h-1 bg-gray-100 rounded mb-0.5"></div>
                    <div className="w-2/3 h-1 bg-gray-100 rounded"></div>
                </div>
                <div className="absolute -top-1 -right-1 bg-green-500 w-2 h-2 rounded-full border border-white"></div>
            </div>

            {/* Day 3 - Draft */}
            <div className="border border-gray-100 rounded-lg p-1.5 flex flex-col gap-1 relative group hover:border-gray-300 transition-colors cursor-pointer">
                <div className="text-[8px] text-gray-400 font-medium">15 Wed</div>
                 <div className="bg-gray-50 rounded border border-gray-100 p-1.5 border-dashed">
                    <div className="flex items-center justify-between mb-1">
                        <Icon icon="mdi:linkedin" width={10} className="text-blue-700" />
                        <span className="text-[7px] bg-gray-200 px-1 rounded text-gray-500">Draft</span>
                    </div>
                    <div className="w-full h-1 bg-gray-200 rounded mb-0.5"></div>
                    <div className="w-1/2 h-1 bg-gray-200 rounded"></div>
                </div>
            </div>
        </div>

        {/* Floating Connection Lines (Decoration) */}
        <div className="absolute top-1/2 -right-4 flex flex-col gap-2">
            <div className="bg-white p-1 rounded-full shadow-md border border-gray-100"><Icon icon="mdi:instagram" width={12} className="text-pink-500"/></div>
            <div className="bg-white p-1 rounded-full shadow-md border border-gray-100"><Icon icon="simple-icons:threads" width={12} className="text-black"/></div>
            <div className="bg-white p-1 rounded-full shadow-md border border-gray-100"><Icon icon="mdi:twitter" width={12} className="text-sky-500"/></div>
        </div>
    </div>
  );
};

export default MultiSourceVisual;
